import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginUser } from '../store/userSlice';
import { setHospitalInfo } from '../store/hospitalSlice';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const result = await dispatch(loginUser({ email, password })).unwrap();

      if (result?.userType === 'hospital') {
        dispatch(setHospitalInfo(result));
        if (result?.requiresPlanSelection) {
          navigate('/hospital-pricing?select=1&return=/hospital-dashboard');
        } else {
          navigate('/hospital-dashboard');
        }
        return;
      }

      dispatch(setHospitalInfo(null));

      if (result?.userDocument?.isAdmin) {
        navigate('/admin-dashboard');
      } else {
        navigate('/user-dashboard');
      }
    } catch (err) {
      if (err?.status === 403) {
        setError(err?.message || 'Account is not eligible to login yet');
        return;
      }
      setError(err?.message || 'Login failed');
    }
  };

  return (
    <div>
      <div className="login-area pt-120 mb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="form-wrapper">
                <div className="form-title">
                  <h3>Log In Here!</h3>
                  <span />
                </div>
                <form onSubmit={handleSubmit}>
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-inner mb-25">
                        <label htmlFor="email">Email*</label>
                        <div className="input-area">
                          <img src="../../public/assets/images/icon/email-2.svg" alt="" />
                          <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="info@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-inner">
                        <label htmlFor="password">Password*</label>
                        <input
                          type="password"
                          name="password"
                          id="password"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <i className="bi bi-eye-slash" id="togglePassword" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-agreement form-inner d-flex justify-content-between flex-wrap">
                        <div className="form-group">
                          <input type="checkbox" id="html" />
                          <label htmlFor="html">Remember Me</label>
                        </div>
                        <Link to="#" className="forgot-pass">
                          Forget Password?
                        </Link>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-inner">
                        <button className="primry-btn-2" type="submit">
                          LogIn
                        </button>
                      </div>
                    </div>
                    <h6>
                      Don&apos;t have an account? <Link to="/register">Sign Up</Link>
                    </h6>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
